<nav mat-tab-nav-bar class="tellus-mat-tab" [tabPanel]="tabPanel">
  @for(tab of tabs$ | async; track tab.name) {
    @if(tab.externalUrl) {
      <a mat-tab-link [href]="tab.externalUrl" target="_blank" rel="noopener noreferrer"
         [isFeatureAvailable]="'tab-' + tab.name"
         [attr.data-cy]='tab.dataCy'>
        {{ tab.name }}&nbsp;<mat-icon class="external-link-icon">open_in_new</mat-icon>
      </a>
    } @else {
      <a mat-tab-link [routerLink]="tab.path" routerLinkActive #rla="routerLinkActive"
         [isFeatureAvailable]="'tab-' + tab.name"
         [active]="rla.isActive" [attr.data-cy]='tab.dataCy'>
        {{ tab.name }}
      </a>
    }
  }
</nav>
<mat-tab-nav-panel #tabPanel />
